"use server";

// Password reset request. Always answers the same way whether or not the email
// has an account, so this form can't be used to find out who is a Frontline rep.

import { headers } from "next/headers";
import { createSupabaseServerClient } from "@/lib/platform/supabase/server";
import { resolveSiteUrl } from "@/lib/platform/auth/recovery";

export type ResetRequestState = { sent: true } | { error: string } | undefined;

export async function requestPasswordReset(
  _prev: ResetRequestState,
  formData: FormData,
): Promise<ResetRequestState> {
  const email = String(formData.get("email") ?? "").trim();
  if (!email || !email.includes("@")) return { error: "Enter the email you signed up with." };

  // The link must come back to this site. Production uses only the configured
  // NEXT_PUBLIC_SITE_URL; dev may fall back to the request origin (Supabase also
  // checks it against its redirect allow-list).
  const origin = resolveSiteUrl(process.env, (await headers()).get("origin"));
  if (!origin) return { error: "Password reset isn't available right now." };
  const supabase = await createSupabaseServerClient();
  const { error } = await supabase.auth.resetPasswordForEmail(email, {
    redirectTo: `${origin}/auth/confirm?next=/reset-password`,
  });
  // Rate-limit errors are worth showing; anything about the address itself is not.
  if (error && error.status === 429) return { error: "Too many requests. Wait a minute and try again." };
  return { sent: true };
}
